import { useState } from 'react';
import { UserRoles } from '@/enums/enums';
import { getUserOptions } from '@/features/user/user.queries';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import Tabs from '@/components/tabs/tabs-custom';

import ClassCategoryTab from './-class-category-tab';
import ClassHomeworkTemplateTab from './-class-homework-template-tab';
import GradingPeriodTab from './-grading-period-tab';
import LessonGradeCategoryTab from './-lesson-grade-category-tab';
import PeriodGradeCategoryTab from './-period-grade-category-tab';

const ContractSettingsRouteSchema = z.object({
  mode: z.enum(['create', 'update']).optional(),
  category: z.number().optional(),
});

export const Route = createFileRoute('/_app/(classes)/classes/settings')({
  validateSearch: zodSearchValidator(ContractSettingsRouteSchema),
  component: StudentSettingsPage,
  beforeLoad: async ({ context }) => {
    const { user } = await context.queryClient.ensureQueryData(getUserOptions);

    if (![UserRoles.Root, UserRoles.Admin, UserRoles.Secretary].includes(user?.role as UserRoles)) {
      throw redirect({
        to: '/',
      });
    }
  },
});

function StudentSettingsPage() {
  const [tab, setTab] = useState('class_category');
  return (
    <Tabs
      tab={tab}
      onChangeTab={setTab}
      tabs={[
        {
          label: 'Κατηγορίες Τμημάτων',
          value: 'class_category',
          content: <ClassCategoryTab />,
        },
        {
          label: 'Κατηγορίες Βαθμων Μαθημάτων',
          value: 'lesson_category',
          content: <LessonGradeCategoryTab />,
        },
        {
          label: 'Κατηγορίες Βαθμών Περιόδου',
          value: 'period_category',
          content: <PeriodGradeCategoryTab />,
        },
        {
          label: 'Περίοδοι Βαθμολογιών',
          value: 'grading_period',
          content: <GradingPeriodTab />,
        },
        {
          label: 'Πρότυπα εργασιών',
          value: 'homework_template',
          content: <ClassHomeworkTemplateTab />,
        },
      ]}
      className='mt-1 overflow-y-auto'
    />
  );
}
